import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    inject,
    input,
    output
} from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { CardContent } from '@models/card-content';
import { NewsService } from '@services/news.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ReleaseReportComponent } from '../../components/release-report/release-report.component';
import { CardComponent } from '../card/card.component';

/**
 * news component
 * which shows latest three news from rss feed on login screen
 * @class NewsComponent
 * @typedef {NewsComponent}
 * @implements {OnInit}
 */
@Component( {
    selector: 'riege-news',
    imports: [ AsyncPipe, CardComponent, ReleaseReportComponent ],
    templateUrl: './news.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './news.component.scss'
} )
export class NewsComponent implements OnInit, OnDestroy {
    readonly count = input.required<number>();
    readonly feed = input.required<string>();
    readonly variant = input<'default' | 'release'>( 'default' );

    hasPosts = output<boolean>();

    /**  lifecycle hook */
    readonly #destroyed: Subject<void> = new Subject<void>();

    #newsService = inject( NewsService );

    /** reference on list of rss feed news */
    newsItems$!: Observable<CardContent[]>;

    /** on init get list of news from rss feed */
    ngOnInit(): void {
        this.getNews();
    }

    getNews() {
        this.newsItems$ = this.#newsService.getRSSNews( this.feed(), this.count() ).pipe( takeUntil( this.#destroyed ) );

        this.newsItems$.subscribe( ( data ) => this.hasPosts.emit( data.length > 0 ) );
    }

    ngOnDestroy(): void {
        this.#destroyed.next();
        this.#destroyed.complete();
    }
}
